import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 3v4a.997 .997 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M11 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5","key":"svg-1"}],["path",{"d":"M8 9h1","key":"svg-2"}],["path",{"d":"M8 12.994l3 0","key":"svg-3"}],["path",{"d":"M8 16.997l2 0","key":"svg-4"}],["path",{"d":"M21 15.994c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5","key":"svg-5"}]]

const IconFileTextShield = createReactComponent('outline', 'file-text-shield', 'FileTextShield', __iconNode);

export default IconFileTextShield;